import  URLImage  from './URLImage.js';
import React from 'react';
import { contentRoot } from '../config.js';


class Stove extends React.Component {
    constructor(props) {

        super(props);
        this.updateDragBounds(props);
        this.imageObj = new Image();
        this.imageObj.onload = props.renderCallBack;
        this.imageObj.src = contentRoot + props.stoveImage;
    }

    updateDragBounds(props) {
        this.stoveDragBounds =
            {
            xMin: (props.offset.x + props.stove.width / 2) * props.scale,
            xMax: (props.offset.x + props.saunaWidth - props.stove.width/2) * props.scale,
            yMin: (props.offset.y+ props.stove.width / 2) * props.scale,
            yMax: (props.offset.y + props.saunaDepth - props.stove.depth/2) * props.scale,
            };
    }

    onDragEnd(e) {
        let x = e.currentTarget.attrs.x - this.props.offset.x;
        let y = e.currentTarget.attrs.y - this.props.offset.y;
        this.props.stovePositionUpdated({ x, y });
    }

    dragBoundFunc(pos) {
        let x = Math.max(Math.min(pos.x, this.stoveDragBounds.xMax), this.stoveDragBounds.xMin);
        let y = Math.max(Math.min(pos.y, this.stoveDragBounds.yMax), this.stoveDragBounds.yMin);
        let distanceToLeftwall = Math.abs(x - this.stoveDragBounds.xMin);
        let distanceTorightwall = Math.abs(x - this.stoveDragBounds.xMax);
        let distanceTobackwall = Math.abs(y - this.stoveDragBounds.yMin);
        let distanceTofrontwall = Math.abs(y - this.stoveDragBounds.yMax);

        if (distanceTobackwall < distanceTofrontwall) {
            if (distanceToLeftwall < distanceTobackwall) {
                x = this.stoveDragBounds.xMin;
            }
            else if (distanceTorightwall < distanceTobackwall) {
                x = this.stoveDragBounds.xMax;
            }
            else {
                y = this.stoveDragBounds.yMin;
            }
        }
        else {
            if (distanceToLeftwall < distanceTofrontwall) {
                x = this.stoveDragBounds.xMin;
            }
            else if (distanceTorightwall < distanceTofrontwall) {
                x = this.stoveDragBounds.xMax;
            }
            else {
                y = this.stoveDragBounds.yMax;
            }
        }
        return {
            x: x,
            y: y
        }
    }

    render() {
        this.updateDragBounds(this.props);
        return <URLImage draggable={this.props.draggable}
            preventDefault={this.props.draggable}
            x={this.props.stovex + this.props.offset.x}
            y={this.props.stovey + this.props.offset.y}
            width={this.props.stove.width}
            height={this.props.stove.depth}
            offset={{ x: this.props.stove.width / 2, y: this.props.stove.depth / 2 }}
            src={contentRoot + this.props.stoveImage}
            dragBoundFunc={this.dragBoundFunc.bind(this)}
            onDragEnd={this.onDragEnd.bind(this)}
            rotation={this.props.rotation}></URLImage>
    }
}

export default Stove;
